export const STATION_BY_SID = (sid) =>
  ({ url: `stations/${sid}` });

export const STATIONS_BY_STATE = (srchState) =>
  ({ url: `stations?state=${srchState}` });

export const STATIONS_BY_STATE_STATUS = (srchState, srchStatus) =>
  ({ url: `stations?state=${srchState}&status=${srchStatus}` });

export const STATIONS_BY_NAME = (srchName) =>
  ({ url: `stations?name=${encodeURIComponent(srchName)}` });

export const CREATE_STATION = (data) =>
  ({
    url: `stations`,
    options: {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }
  });

export const DELETE_STATION = (id) =>
  ({
    url: `stations/${id}`,
    options: {
      method: 'DELETE'
    }
  });

export const UPDATE_STATION = (id, data) =>
  ({
    url: `stations/${id}`,
    options: {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }
  });

export const OWNER_BY_ID = (id) =>
  ({ url: `owners/${id}` });

export const OWNERS_BY_NAME = (srchName) =>
  ({ url: `owners?nameIncludes=${encodeURIComponent(srchName)}` });

export const OWNER_BY_EXACT_NAME = (name) =>
  ({ url: `owners?name=${encodeURIComponent(name)}` });

export const CREATE_OWNER = (data) =>
  ({
    url: `owners`,
    options: {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }
  });

export const DELETE_OWNER = (id) =>
  ({
    url: `owners/${id}`,
    options: {
      method: 'DELETE'
    }
  });

export const UPDATE_OWNER = (id, data) =>
  ({
    url: `owners/${id}`,
    options: {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }
  });